import { DoseRangeInfoDto } from '../../webapi/index';
import { DoseRange } from './DoseRange';

export class DoseRangeInfo extends DoseRange {
  constructor(private readonly infoDto: DoseRangeInfoDto) {
    super(infoDto);
  }

  get MaxMinInformation() {
    return this.infoDto.MaxMinInformation;
  }
}
